import { render, staticRenderFns } from "./deposit-status.vue?vue&type=template&id=360178f4&scoped=true"
import script from "./deposit-status.vue?vue&type=script&lang=js"
export * from "./deposit-status.vue?vue&type=script&lang=js"
import style0 from "./deposit-status.vue?vue&type=style&index=0&id=360178f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "360178f4",
  null
  
)

export default component.exports